import { LogOut, ShieldCheck, Building2, Bell } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { BrandLogo } from "@/components/BrandLogo";

export default function Navbar({ notifCount = 0, offerCount = 0, onBellClick }) {
  const { user, logout } = useAuth();
  const isAdmin = user?.role === "admin";
  return (
    <header data-testid="navbar" className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <div className="flex items-center gap-3">
          <BrandLogo size={44} textClass="text-base sm:text-xl" />
          <span className={`ml-2 hidden sm:inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${isAdmin ? "bg-red-500/10 text-red-600 border border-red-500/30" : "bg-blue-500/10 text-blue-600 border border-blue-500/30"}`}>
            {isAdmin ? <ShieldCheck className="h-3.5 w-3.5" /> : <Building2 className="h-3.5 w-3.5" />}
            {isAdmin ? "Administrateur" : "Garagiste"}
          </span>
        </div>
        <div className="flex items-center gap-3">
          <button type="button" className="relative p-1.5 rounded-full hover:bg-muted" data-testid="notif-bell" onClick={onBellClick} title={offerCount ? `${offerCount} nouvelle(s) offre(s) flash` : "Notifications"}>
            <Bell className="h-5 w-5 text-muted-foreground" />
            {offerCount > 0 && (
              <span className="absolute -top-1.5 -left-2 h-4 min-w-4 px-1 rounded-full bg-amber-500 text-white text-[10px] font-bold flex items-center justify-center flash-pulse" data-testid="offer-notif-count">{offerCount}</span>
            )}
            {notifCount > 0 && (
              <span className="absolute -top-2 -right-2 h-4 min-w-4 px-1 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center" data-testid="notif-count">{notifCount}</span>
            )}
          </button>
          <div className="text-right hidden sm:block leading-tight">
            <div className="text-sm font-semibold">{user?.name}</div>
            <div className="text-xs text-muted-foreground">{user?.garage_name || user?.email}</div>
          </div>
          <Button data-testid="logout-btn" variant="ghost" size="icon" onClick={logout} title="Déconnexion">
            <LogOut className="h-5 w-5" />
          </Button>
        </div>
      </div>
      <div className="tricolor-bar" data-testid="tricolor-bar" />
    </header>
  );
}
